const newContainer = () => import("@/layouts/Default.vue");
const myVoice = () => import("../views/myVoice/myVoice.vue");
const ProcessingMethodsList = () =>
  import("../views/processingMethods/ProcessingMethodsList.vue");
const adaptiveTrainingCourseList = () =>
  import("../views/adaptive-training-course/adaptiveTrainingCourseList.vue");
const userAdaptiveTrainingCourseList = () =>
  import(
    "../views/adaptive-training-course/user-side/userAdaptiveTrainingCourseList.vue"
  );
const userAdaptiveTrainingCourseDetail = () =>
  import(
    "../views/adaptive-training-course/user-side/userAdaptiveTrainingCourseDetail.vue"
  );
const userAdaptiveTrainingCourseAzmoon = () =>
  import(
    "../views/adaptive-training-course/user-side/userAdaptiveTrainingCourseAzmoon.vue"
  );
const userAdaptiveTrainingCourseHistory = () =>
  import(
    "../views/adaptive-training-course/user-side/userAdaptiveTrainingCourseHistory.vue"
  );
const adaptiveTrainingCourseHistory = () =>
  import("../views/adaptive-training-course/adaptiveTrainingCourseHistory.vue");

const flowList = () => import("../views/flow/FlowList.vue");
const jobsFlowList = () => import("../views/jobs-flow/jobsFlowList.vue");
const myConversationsManagement = () =>
  import(
    "../views/conversation/my-conversations-management/myConversationsManagement.vue"
  );
const myConversations = () =>
  import("../views/conversation/my-conversations/myConversations.vue");
const allConversationsList = () =>
  import("../views/all-conversations/allConversationsList.vue");
const conversationHistory = () =>
  import("../views/all-conversations/conversationHistory.vue");

export const intelligenceRoutes: any[] = [
  {
    path: "/intelligence",
    redirect: "/dashboard",
    name: "intelligence",
    meta: {
      label: "هوشمند سازی",
      moduleName: "intelligence",
    },
    component: newContainer,
    children: [
      {
        path: "my_voice",
        name: "my_voice",
        redirect: "/intelligence/my_voice/list",
        meta: {
          label: "صوت‌های من",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "myVoice",
            component: myVoice,
            meta: {
              label: "صوت‌های من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "processing_methods",
        name: "processing_methods",
        redirect: "/intelligence/processing_methods/list",
        meta: {
          label: "مدیریت روش‌های پردازش",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "processingMethods",
            component: ProcessingMethodsList,
            meta: {
              label: "مدیریت روش‌های پردازش",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "adaptive-training-course",
        name: "adaptive_training_course",
        redirect: "/intelligence/adaptive-training-course/list",
        meta: {
          label: "دوره‌های آموزشی",
          requiresAuth: true,
          redesigned: true,
          hasShowParvandehNotification: false,
          hasAudioNotification: false,
        },
        children: [
          {
            path: "list",
            name: "adaptive-training-course-list",
            component: adaptiveTrainingCourseList,
            meta: {
              label: "دوره‌های آموزشی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/history",
            name: "adaptive-training-course-history",
            component: adaptiveTrainingCourseHistory,
            meta: {
              label: "تاریخچه موردکاوی های",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "user-adaptive-training-course",
        name: "user_adaptive_training_course",
        redirect: "/intelligence/user-adaptive-training-course/list",
        meta: {
          label: "برنامه‌های آموزشی",
          requiresAuth: true,
          redesigned: true,
          hasShowParvandehNotification: false,
          hasAudioNotification: false,
        },
        children: [
          {
            path: "list",
            name: "user-adaptive-training-course-list",
            component: userAdaptiveTrainingCourseList,
            meta: {
              label: "برنامه‌های آموزشی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/detail",
            name: "user-adaptive-training-course-detail",
            component: userAdaptiveTrainingCourseDetail,
            meta: {
              label: "جزییات برنامه آموزشی",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
          {
            path: ":code/azmoon",
            name: "user-adaptive-training-course-azmoon",
            component: userAdaptiveTrainingCourseAzmoon,
            meta: {
              label: "جزییات برنامه آموزشی",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
          {
            path: ":code/history",
            name: "user-adaptive-training-course-history",
            component: userAdaptiveTrainingCourseHistory,
            meta: {
              label: "تاریخچه موردکاوی های",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "flow",
        name: "flow-management",
        redirect: "/intelligence/flow/list",
        meta: {
          label: "مدیریت جریان هوشمند",
          requiresAuth: true,
          redesigned: true,
          hasShowParvandehNotification: false,
          hasAudioNotification: false,
        },
        children: [
          {
            path: "list",
            name: "flow",
            component: flowList,
            meta: {
              label: "مدیریت جریان هوشمند",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "jobs-flow",
        name: "jobs_flow",
        redirect: "/intelligence/jobs-flow/list",
        meta: {
          label: "تاریخچه جریان هوشمند من",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "jobs_-low-list",
            component: jobsFlowList,
            meta: {
              label: "تاریخچه جریان هوشمند من",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "my-conversations-management",
        name: "my_conversations",
        redirect: "/intelligence/my-conversations-management/conversations",
        meta: {
          label: "گفتگو ها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "conversations",
            name: "my-conversations-management",
            component: myConversationsManagement,
            meta: {
              label: "مدیریت گفتگو‌های من",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
            },
          },
        ],
      },
      {
        path: "my-conversations",
        name: "my_limit_conversations",
        redirect: "/intelligence/my-conversations/conversations",
        meta: {
          label: "گفتگو ها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "conversations",
            name: "my-conversations",
            component: myConversations,
            meta: {
              label: "گفتگو‌های من",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
            },
          },
        ],
      },
      {
        path: "all-conversations",
        name: "all-conversations",
        redirect: "/intelligence/all-conversations/list",
        meta: {
          label: "گفتگو ها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "all-conversations-list",
            component: allConversationsList,
            meta: {
              label: "مدیریت گفتگو‌ها",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
            },
          },
          {
            path: ":code/history",
            name: "conversation-history",
            component: conversationHistory,
            meta: {
              label: "تاریخچه گفتگو",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
            },
          },
        ],
      },
    ],
  },
];
